import { EZoneCleaningHistoryItemStatus } from 'enums';

export const mockFloorPath = [
  { x: -180, y: -120 },
  { x: 180, y: -120 },
  { x: 180, y: 120 },
  { x: -180, y: 120 },
];

const mockZone1 = {
  path: [
    { x: -180, y: -120 },
    { x: 180, y: -120 },
    { x: 180, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 120 },
    { x: -180, y: 120 },
  ],
  pinPosition: {
    x: -140,
    y: 0,
  },
};

const mockZone2 = {
  path: [
    { x: -180, y: 0 },
    { x: 180, y: 0 },
    { x: 180, y: 120 },
    { x: -180, y: 120 },
  ],
  pinPosition: {
    x: 0,
    y: 10,
  },
};

const mockZone3 = {
  path: [
    { x: 0, y: -120 },
    { x: 180, y: -120 },
    { x: 180, y: 120 },
    { x: 0, y: 120 },
  ],
  pinPosition: {
    x: 140,
    y: 10,
  },
};

export const mockZones = [mockZone1, mockZone2, mockZone3];

export const mockHistoryItems = [
  {
    id: 1,
    status: EZoneCleaningHistoryItemStatus.COMPLETED,
    time: '8:37 AM',
    scheduledTime: '8:37 AM',
    date: 'Wednesday September 31, 2021',
    serviceItems: [
      {
        id: 1,
        name: 'cleaned',
      },
      {
        id: 2,
        name: 'disinfected',
      },
      {
        id: 3,
        name: 'refilled',
      },
      {
        id: 4,
        name: 'serviced',
      },
      {
        id: 5,
        name: 'sanitized',
      },
    ],
  },
  {
    id: 2,
    status: EZoneCleaningHistoryItemStatus.MISSED,
    time: '10:37 AM',
    scheduledTime: '8:37 AM',
    date: 'Wednesday September 31, 2021',
    serviceItems: [
      {
        id: 1,
        name: 'cleaned',
      },
      {
        id: 2,
        name: 'disinfected',
      },
      {
        id: 3,
        name: 'refilled',
      },
      {
        id: 4,
        name: 'serviced',
      },
      {
        id: 5,
        name: 'sanitized',
      },
    ],
  },
  {
    id: 3,
    status: EZoneCleaningHistoryItemStatus.ADDITIONAL_SERVICE,
    time: '12:37 PM',
    date: 'Wednesday September 31, 2021',
    serviceItems: [
      {
        id: 1,
        name: 'cleaned',
      },
      {
        id: 2,
        name: 'disinfected',
      },
      {
        id: 3,
        name: 'refilled',
      },
      {
        id: 4,
        name: 'serviced',
      },
      {
        id: 5,
        name: 'sanitized',
      },
    ],
  },
  {
    id: 4,
    scheduledTime: '8:37 AM',
    date: 'Wednesday September 31, 2021',
    serviceItems: [
      {
        id: 1,
        name: 'cleaned',
      },
      {
        id: 2,
        name: 'disinfected',
      },
      {
        id: 3,
        name: 'refilled',
      },
      {
        id: 4,
        name: 'serviced',
      },
      {
        id: 5,
        name: 'sanitized',
      },
    ],
  },
];
